import { MutationTree } from "vuex";

import { Invoice, SubscriptionState } from "../types";

const mutations: MutationTree<SubscriptionState> = {
  setAllSubscriptionPlans(state, subscriptionPlans) {
    state.plans = subscriptionPlans;
  },
  setCurrentSubscriptionPlan(state, subscriptionPlan) {
    state.currentSubscriptionPlan = subscriptionPlan;
  },
  setAllCards(state, cards) {
    state.cards = cards;
  },
  setAllInvoices(state, invoices: Invoice[]) {
    state.invoices = invoices;
  },
  setVerificationQuota(state, verificationQuota) {
    state.verificationQuota = verificationQuota;
  },
  setVerificationUsedQuota(state, verificationQuotaUsed) {
    state.verificationQuotaUsed = verificationQuotaUsed;
  },
  setAmlQuota(state, amlQuota) {
    state.amlQuota = amlQuota;
  },
  setAmlQuotaUsed(state, amlQuotaUsed) {
    state.amlQuotaUsed = amlQuotaUsed;
  },
  setIsAccountSandbox(state, isSandbox) {
    state.isSandbox = isSandbox;
  },
  setQuotaExpirationDate(state, expirationDate: string) {
    state.quotaExpirationDate = expirationDate;
  },
  setQuotaStartDate(state, startDate: string) {
    state.quotaStartDate = startDate;
  },
  setMode(state, mode: number) {
    state.mode = mode;
  },
  setPricePerVerification(state, pricePerVerification: number) {
    state.pricePerVerification = pricePerVerification;
  },
  setAutomaticPep(state, enabled: boolean) {
    state.hasPepEnabled = enabled;
  },
  setAutomaticSanction(state, enabled: boolean) {
    state.hasSanctionEnabled = enabled;
  },
  setAutomaticKyb(state, enabled: boolean) {
    state.hasKybEnabled = enabled;
  },
};

export default mutations;
